var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "cvpage" },
    [
      _c(
        "b-container",
        [
          _vm.selectedCV === undefined
            ? _c(
                "b-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "PageContent",
                        {
                          attrs: {
                            description: _vm.description,
                            linksTitle: _vm.t.CV_Tool_Related_Links,
                            links: _vm.links,
                            cvLinkText: _vm.cvLinkText,
                            cvLinkUrl: _vm.cvLinkUrl,
                            applicationLinkText: _vm.applicationLinkText,
                            applicationLinkUrl: _vm.applicationLinkUrl,
                            profileLinkText: _vm.profileLinkText,
                            profileLinkUrl: _vm.profileLink,
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "file-text",
                                  variant: "primary",
                                },
                              }),
                              _c("div", { staticClass: "description" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.t.CV_Tool_Cover_Letter_Top_Description
                                  )
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm.layoutTags !== undefined && _vm.layoutTags.length > 0
                        ? _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "3", offset: "9" } },
                                [
                                  _c("b-select", {
                                    attrs: { options: _vm.layoutTags },
                                    on: { change: _vm.selectTag },
                                    model: {
                                      value: _vm.selectedTag,
                                      callback: function ($$v) {
                                        _vm.selectedTag = $$v
                                      },
                                      expression: "selectedTag",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "b-row",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("CardList", {
                                attrs: {
                                  items: _vm.filteredItems,
                                  t: {
                                    automaticCvTemplate:
                                      _vm.t.CV_Tool_Automatic_CvTemplate,
                                    cvTemplate: _vm.t.CV_Tool_CvTemplate,
                                    noTemplates: _vm.t.CV_Tool_No_Templates,
                                    selectDesign: _vm.t.CV_Tool_Select_Design,
                                  },
                                },
                                on: { clickItem: _vm.selectCV },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.documents.length > 0
            ? _c(
                "b-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "b-col",
                    [
                      _vm.selectedCV !== undefined
                        ? _c("CvView", {
                            attrs: {
                              selected: _vm.selectedCV,
                              langOptions: _vm.lang,
                              url: _vm.url,
                              siteLanguage: _vm.siteLanguage,
                              competencesLink: _vm.competencesLink,
                              linkToDocuments: _vm.linkToDocuments,
                              documentsLinkName: _vm.documentsLinkName,
                            },
                            on: {
                              clearSelect: function ($event) {
                                return _vm.clearSelection()
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }